import { BadgeSummaryType } from "Resources/ServerInterfaceProfile";
import { atom } from "jotai";

export const badgesAtom = atom<BadgeSummaryType[]>([]);

export const openBadgeAtom = atom<null | BadgeSummaryType>(
	null as BadgeSummaryType | null
);
